module.exports = __webpack_public_path__ + "img/b2.d704328f.svg";